import React from "react";
import {
  Type,
  Select,
  Button,
  Anchor,
} from "discover.medical.react-component-library";
import "./index.css";
import { WebAuth } from "auth0-js";
import axios from "axios";
import { products } from "../../../../shared/products";
import {
  logSignInSSOGoClicked,
  logSignInOtherLink,
} from "../../../../shared/analytics";

const initialLink = "Select organization";

class GroupLogin extends React.Component {
  constructor(props) {
    super(props);
    const { SSOConnections = [] } = props;
    this.state = {
      username: props.username,
      password: "",
      error: null,
      isContinueVisible: false,
      isSubmitDisabled: false,
      captcha: null,
      SSOConnections,
      SSOConnectionsError: false,
      selectedLink: initialLink,
      webAuth: null,
    };
    this.handleChange = this.handleChange.bind(this);
  }

  fetchSSOConnections() {
    const { productName, config = {}, isMobileApp, eisSource } = this.props;
    const { myAccountURL } = config;
    axios
      .get(
        `${myAccountURL}/login-support/products/${productName}/sso-connections?isEhr=${
          eisSource === "ehr"
        }&isMobile=${isMobileApp}`
      )
      .then((res) =>
        this.setState({ SSOConnections: res.data, SSOConnectionsError: false })
      )
      .catch(() =>
        this.setState({ SSOConnections: [], SSOConnectionsError: true })
      );
  }

  handleChange = (e) => {
    this.setState({ selectedLink: e.target.value });
  };

  onGoClickHandler = (connectionName) => {
    const { config } = this.props;
    const { selectedLink } = this.state;

    const params = Object.assign(
      {
        domain: config.auth0Domain,
        clientID: config.clientID,
        redirectUri: config.callbackURL,
        responseType: "code",
        overrides: {
          __tenant: config.auth0Tenant,
          __token_issuer: "https://" + config.auth0Domain,
        },
      },
      config.internalOptions
    );

    const webAuth = new WebAuth(params);
    this.setState({ webAuth: webAuth });
    const authorizeObj = {
      connection: connectionName ? connectionName : selectedLink,
    };

    if (connectionName && config.dict?.signin?.title) {
      authorizeObj.login_hint = `site:${
        products[config.dict.signin.title].theme
      }`;
    }
    return webAuth.authorize(authorizeObj);
  };

  componentDidMount() {
    this.fetchSSOConnections();
  }

  render() {
    const {
      origin,
      showLinks,
      productName,
      isMobileApp,
      showSSOForm,
      showAsDropdown,
      showAdditionalOptions,
    } = this.props;

    const { selectedLink, SSOConnections, SSOConnectionsError } = this.state;

    const ssoErrorMessage = "Couldn’t load organizations. Please refresh";
    const interfaceId = productName === "dh" ? "dhe" : productName;

    const showSelect = SSOConnections.length > 40 || showAsDropdown;

    return (
      <div className="GroupLogin" data-testid="group-login">
        {showSSOForm &&
          (SSOConnections.length > 0 || SSOConnectionsError) && (
            <>
              <Type element="h2" fontFamily="secondary" marginBottom="sm">
                Sign in via an organization
              </Type>
              <div className="GroupLogin__form">
                {showSelect ? (
                  <>
                    <Select
                      id="selectGroupLogin"
                      data-testid="selectGroupLogin"
                      name="group-login-options"
                      value={selectedLink}
                      onChange={this.handleChange}
                      aria-label="organization"
                    >
                      {SSOConnectionsError && (
                        <Select.Option value="">
                          {ssoErrorMessage}
                        </Select.Option>
                      )}
                      {!SSOConnectionsError && (
                        <>
                          {" "}
                          <Select.Option value={initialLink}>
                            {initialLink}
                          </Select.Option>
                          {SSOConnections.map((sso) => (
                            <Select.Option
                              value={sso.connectionName}
                              data-testid="sso-option"
                            >
                              {sso.customerName}
                            </Select.Option>
                          ))}
                        </>
                      )}
                    </Select>
                    <Button
                      className="GroupLogin__button"
                      variant="primary"
                      size="sm"
                      id="button-go"
                      data-testid="button-go"
                      type="button"
                      disabled={
                        !selectedLink ||
                        selectedLink === initialLink ||
                        selectedLink === ssoErrorMessage
                      }
                      onClick={() => {
                        logSignInSSOGoClicked({ org: selectedLink });
                        this.onGoClickHandler();
                      }}
                    >
                      GO
                    </Button>
                  </>
                ) : SSOConnectionsError ? (
                  <Type fontSize="sm">{ssoErrorMessage}</Type>
                ) : (
                  <div className="List">
                    <ul>
                      {SSOConnections.map((sso) => (
                        <li>
                          <Anchor
                            fontSize="sm"
                            fontWeight="semibold"
                            href="#"
                            onClick={() => {
                              logSignInSSOGoClicked({
                                org: sso.connectionName,
                              });
                              this.onGoClickHandler(sso.connectionName);
                            }}
                          >
                            {sso.customerName}
                          </Anchor>
                        </li>
                      ))}
                    </ul>
                  </div>
                )}{" "}
              </div>
            </>
          )}
        {showAdditionalOptions && (
          <>
            <Type
              element="h3"
              styledAs="p"
              fontSize="sm"
              fontFamily="secondary"
              marginBottom="sm"
            >
              Additional Options
            </Type>
            <ul className="List">
            <li>
            <Anchor
              onClick={(e) => {
                logSignInOtherLink({ link: e.target.innerText });
                this.onGoClickHandler("dispatcher-openathens");
              }}
              fontWeight="semibold"
              fontSize="sm"
              display="block"
            >
              OpenAthens
            </Anchor></li>
            
            {!isMobileApp && (
              <li>
              <Anchor
                href={`${origin}/?cust=dispatcher&acr_values=shib&login_hint=site:${interfaceId}`}
                onClick={(e) => {
                  logSignInOtherLink({ link: e.target.innerText });
                }}
                fontWeight="semibold"
                fontSize="sm"
                display="block"
              >
                EBSCO's Institutional Locator
              </Anchor></li>
            )}
            {!isMobileApp && showLinks && (
              <li><Anchor
                href="https://auth.dynamed.com/"
                onClick={(e) => {
                  logSignInOtherLink({ link: e.target.innerText });
                }}
                fontWeight="semibold"
                fontSize="sm"
                display="block"
              >
                Old Institutional Sign In Page
              </Anchor></li>
            )}
            </ul>
          </>
        )}
      </div>
    );
  }
}

export default GroupLogin;
